import { listReservations } from '@/modules/reservations/services/reservationRepository';
import type { Reservation, ReservationStatus } from '@/modules/reservations/types';
import { todayIsoDate } from '@/modules/reservations/utils/dateRange';
import { isBlockingReservation } from '@/modules/reservations/utils/reservationFilters';

export type ItemReservationOverlay = {
  reservationId: string;
  title: string;
  status: ReservationStatus;
  startDate: string;
  endDate: string;
};

function reservationCoversDate(reservation: Reservation, date: string): boolean {
  return date >= reservation.startDate && date <= reservation.endDate;
}

/**
 * Mapa itemId → reserva bloqueante activa en la fecha dada (por defecto hoy).
 * No modifica el estado operativo del ítem en Firestore.
 */
export async function fetchItemReservationOverlays(
  asOfDate: string = todayIsoDate(),
): Promise<Map<string, ItemReservationOverlay>> {
  const reservations = await listReservations();
  const map = new Map<string, ItemReservationOverlay>();

  for (const reservation of reservations) {
    if (!isBlockingReservation(reservation)) continue;
    if (!reservationCoversDate(reservation, asOfDate)) continue;

    for (const itemId of reservation.inventoryItemIds) {
      if (!map.has(itemId)) {
        map.set(itemId, {
          reservationId: reservation.id,
          title: reservation.title,
          status: reservation.status,
          startDate: reservation.startDate,
          endDate: reservation.endDate,
        });
      }
    }
  }

  return map;
}
